import { Component, Element, h, Host, State } from '@stencil/core';

interface Section {
  anchor: string;
  title: string;
  active: boolean;
  element: HTMLElement;
}

@Component({
  tag: 'mama-anker-navigation',
  styleUrl: './mama-anker-navigation.scss',
})
export class MamaAnkerNavigation {
  @Element() el!: HTMLElement;
  @State() sections!: Section[];

  componentWillLoad() {
    this.sections = (Array.from(document.querySelectorAll('[data-anker-navigation-label]')) as HTMLLinkElement[]).map((section, index) => {
      return {
        anchor: '#' + section.dataset.for,
        title: section.dataset.ankerNavigationLabel as string,
        active: index === 0,
        element: section,
      };
    });

    this.el.closest('.row')?.classList.add('tablet-reverse');
  }

  handleChange(event: Event) {
    const target = event.target as HTMLSelectElement;

    if (target) {
      const activeSection = this.sections.filter(section => section.anchor === target.value).find(_ => true) as Section;
      this.scrollIntoView(activeSection, event);
    }
  }

  scrollIntoView(section: Section, event?: Event) {
    event.preventDefault();

    const targetSection = window.document.querySelector(section.anchor);

    if (targetSection) {
      window.history.replaceState(undefined, undefined, section.anchor);
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  renderMobileMenu() {
    if (!this.sections || !this.sections.length) {
      return;
    }
    return (
      <div class="navigation navigation-mobile">
        <div class="form-group">
          <select class="form-control" onChange={event => this.handleChange(event)}>
            {this.sections.map(section => (
              <option value={section.anchor}>{section.title}</option>
            ))}
          </select>
        </div>
      </div>
    );
  }

  renderDesktopMenu() {
    if (!this.sections || !this.sections.length) {
      return;
    }
    return (
      <div class="navigation navigation-desktop">
        {this.sections.map(section => (
          <a href={section.anchor} onClick={event => this.scrollIntoView(section, event)}>
            {section.title}
          </a>
        ))}
      </div>
    );
  }

  render() {
    return (
      <Host hidden={!this.sections || !this.sections.length}>
        <div class="navigation-wrap">
          <label>Auf dieser Seite:</label>
          {this.renderMobileMenu()}
          {this.renderDesktopMenu()}
        </div>
      </Host>
    );
  }
}
